import template from "./markdown-viewer.html";
import "./markdown-viewer.less";
import marked from "marked";

function Controller($sce) {
	const ctrl = this;

	ctrl.$onChanges = (changes) => {
		if(changes && changes.content) {
			ctrl.render();
		}
	};

	ctrl.render = () => {
		if(ctrl.content === null || ctrl.content === undefined || ctrl.content === "") {
			ctrl.html = "";
			return;
		}
		try {
			const html = marked(ctrl.content);
			ctrl.html = $sce.trustAsHtml(html);
		}catch(e) {
			ctrl.html = $sce.trustAsHtml(String(ctrl.content));
		}
	};
}
Controller.$inject = ["$sce"];

export default angular.module("vesl.components.markdown-to-html", []).component("markdownToHtml", {
	bindings: {
		content: "<"
	},
	controller: Controller,
	template
}).name;
